export const SPARK_TYPE_LABEL = {
  purchase: 'Покупка',
  promo: 'Промокод',
  gift_interview: 'Подарок за интервью',
  match_spend: 'Списание на метч',
  refund: 'Возврат',
  referral_bonus: 'Реферальный бонус',
};
